import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../shared.service';
import { SecureSessionService } from '../services/secure-session.service';
import { AssetAuthService } from '../services/asset-auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { CONSENT_VERSION, CONSENT_UPDATED_DATE } from './consent.config';
import { FeatureFlagService } from '../services/feature-flag.service';
import { OrganizationSettingsService } from '../services/organization-settings.service';
import { GlobalSettingsService } from '../services/global-settings.service';
import { ErpAccessService } from '../services/erp-access.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  isHidden = false;

  schoolCode = '';
  schoolName = '';
  schoolLogo = '';
  schoolLocation = '';

  /** Right-pane showcase state: closed by default, opens fullscreen marquee on tile click. */
  showcaseOpen = false;
  showcaseStart: 'product' | 'school' = 'product';

  openShowcase(start: 'product' | 'school'): void {
    this.showcaseStart = start;
    this.showcaseOpen = true;
  }
  closeShowcase(): void {
    this.showcaseOpen = false;
  }

  /** Terms & Conditions modal state */
  termsOpen = false;
  policyTab: 'terms' | 'privacy' | 'refund' | 'payment' = 'terms';
  openPolicy(tab: 'terms' | 'privacy' | 'refund' | 'payment' = 'terms'): void {
    this.policyTab = tab; this.termsOpen = true;
  }
  openTerms(): void  { this.openPolicy('terms'); }
  closeTerms(): void { this.termsOpen = false; }

  /** Agreement checkbox state — pre-checked, but enforced: unchecking disables Login. */
  agreedToTerms = true;

  /** Versioned consent metadata sent with every login request. */
  readonly consentVersion = CONSENT_VERSION;
  readonly consentUpdatedDate = CONSENT_UPDATED_DATE;

  toggleBox() {
    this.isHidden = !this.isHidden;
  }
  username: string = '';
  password: string = '';
  isLoading: boolean = false;
  showPasswordVal: boolean = false;
  isSubmitted: boolean = false
  role: string = ''
  private roles: string[] = []; // Store roles after login
  loginData: any;
    sessionData: any;
  sessionStorage: any;
  constructor(
    private authService: SharedService,
    private session: SecureSessionService,
    private assetAuthService: AssetAuthService,
    private router: Router,
    private http: HttpClient,
    private featureFlagService: FeatureFlagService,
    private organizationSettings: OrganizationSettingsService,
    private globalSettings: GlobalSettingsService,
    private erpAccessService: ErpAccessService
  ) {
    this.authService.loading$.subscribe((loadingState: boolean) => {
      this.isLoading = loadingState;
    });
  }

  ngOnInit(): void {
    this.loadSchoolFromGds();
  }

  /**
   * Fetch organisation details from GDS using the configured baseUrl.
   * Populates logo, school name, org code, and location on the login page.
   */
  private loadSchoolFromGds(): void {
    const baseApi = environment.baseUrl;
    const url = `${environment.apiUrl}Gds/organization-by-base-api?baseApi=${encodeURIComponent(baseApi)}`;

    this.http.get<any>(url).subscribe({
      next: (res) => {
        const data = res?.data;
        this.organizationSettings.setAdmissionNumberLabel(data?.admissionNumber);
        this.organizationSettings.setFaceAuthDeviceSettings(data?.faceAuthDeviceSettings);
        this.globalSettings.setCountry(data?.country);
        if (!data) return;
        this.schoolName     = data.orgName     || '';
        this.schoolCode     = data.orgCode != null ? String(data.orgCode) : '';
        this.schoolLogo     = data.organizationImage || '';
        this.schoolLocation = data.location    || '';
        if (data.noraPulse) {
          this.featureFlagService.setFlags(data.noraPulse);
        }
        this.erpAccessService.setScope(data?.erpAccessScope);
      },
      error: () => {
        // Keep the fallback values rendered by the template.
      }
    });
  }

  login() {
    this.isSubmitted = true;

    // Enforce policy acceptance (the checkbox is pre-checked; this guards an unchecked submit).
    if (!this.agreedToTerms) {
      // alert('Please accept the Terms, Privacy, Refund & Payment Policy to continue.');
      return;
    }

    // Handle Asset Management authentication
    if (this.role === 'asset-management') {
      this.loginAssetManagement();
      return;
    }

    // Legacy authentication logic for other modules
    // if(this.username=='hrms@mail.com'&& this.password=='hrms@123'){
    //        this.roles = ['hrms'];
    //         this.loginData = ['hrms'];
    //         localStorage.setItem("loginData", JSON.stringify(this.loginData));
    //         this.sessionData = [{ role: 'hrms', schoolId: '1', id: '1', email: 'hrms@mail.com', academicYearId: '1' }];
    //         this.session.setSession(JSON.stringify(this.sessionData));
    //         this.router.navigate(['/hrms']);
    // }
    // else if(this.username=='super-admin@mail.com'&& this.password=='super-admin@123'){
    //        this.roles = ['super-admin'];
    //         this.loginData = ['super-admin'];
    //         localStorage.setItem("loginData", JSON.stringify(this.loginData));
    //         this.sessionData = [{ role: 'super-admin', schoolId: '1', id: '1', email: 'super-admin@mail.com', academicYearId: '1' }];
    //         this.session.setSession(JSON.stringify(this.sessionData));
    //         this.router.navigate(['/super-admin']);
    // }
    // else if(this.username=='digital@mail.com'&& this.password=='digital@123'){
    //        this.roles = ['digital-assets'];
    //         this.loginData = ['digital-assets'];
    //         localStorage.setItem("loginData", JSON.stringify(this.loginData));
    //         this.sessionData = [{ role: 'digital-assets', schoolId: '1', id: '1', email: 'digital@mail.com', academicYearId: '1' }];
    //         this.session.setSession(JSON.stringify(this.sessionData));
    //         this.router.navigate(['/digital-assets']);
    // }
    //  else if(this.username=='visitor@mail.com'&& this.password=='visitor@123'){
    //        this.roles = ['super_admin'];
    //         this.loginData = ['visitor-management'];
    //         localStorage.setItem("loginData", JSON.stringify(this.loginData));
    //         this.sessionData = [{
    //         roles: this.roles,
    //         schoolId: '1',
    //         id: 'sdadas',
    //         email: 'visitor@mail.com',
    //         academicYearId: '1'
    //       }];
    //       this.session.setSession(JSON.stringify(this.sessionData));
    //         this.router.navigate(['/user']);
    // }
   else if (this.username && this.password) {
      if (!this.authService.login(this.username, this.password, this.consentVersion, this.consentUpdatedDate)) {
        alert('Invalid credentials');
      }
    }
  }

  /**
   * Handle Asset Management authentication
   */
  private loginAssetManagement(): void {
    if (!this.username || !this.password) {
      alert('Please enter both email and password');
      return;
    }
    console.log('Logging in to Asset Management with', this.username);

    this.isLoading = true;
    
    this.assetAuthService.login({
      email: this.username,
      password: this.password
    }).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.success) {
          console.log('Asset Management login successful:', response.data.user);
          
          // Set the session data for compatibility with existing auth system
          this.roles = ['assetmanagement'];
          this.loginData = ['assetmanagement'];
          localStorage.setItem("loginData", JSON.stringify(this.loginData));
          this.sessionData = [{ 
            role: 'assetmanagement', 
            schoolId: '1', 
            id: response.data.user.id, 
            email: response.data.user.email, 
            academicYearId: '1',
            name: response.data.user.name,
            userRole: response.data.user.role
          }];
          this.session.setSession(JSON.stringify(this.sessionData));
          
          this.router.navigate(['/assetmanagement']);
        } else {
          alert(response.message || 'Login failed');
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Asset Management login error:', error);
        alert(error.message || 'Login failed. Please try again.');
      }
    });
  }

  showPassword() {
    this.showPasswordVal = !this.showPasswordVal;
  }

  roleOption(role: string) {
    if (role != this.role) {
      this.role = role
      if (role === 'admin') {
        this.username = 'admin@gmail.com';
        this.password = 'Admin@123';
      } else if (role === 'teacher') {
        this.username = 'manualqat@gmail.com';
        this.password = 'Teacher@123';
        //  this.username = "anatt@example.com"
        // this.password = "Admin@123"
      } else if (role === 'parent') {
        // this.username = "parent@gmail.com"
        // this.password = "parent"
        this.username = 'benny@gmail.com';
        this.password = 'Benny@123';
      } else if (role === 'transport') {
        this.username = 'akhil@gmail.com';
        this.password = 'Akhil@123';
      }
      else if (role === 'fee-management') {
        this.username = 'acc@gmail.com';
        this.password = 'Acc@12345';
      }
       else if (role === 'hrms') {
        this.username = 'hrms@mail.com';
        this.password = 'hrms@123';
      }
       else if (role === 'super-admin') {
        this.username = 'super-admin@mail.com';
        this.password = 'super-admin@123';
      }
       else if (role === 'digital-assets') {
        this.username = 'digital@mail.com';
        this.password = 'digital@123';
      }
      else if (role === 'visitor-management') {
        this.username = 'visitor@mail.com';
        this.password = 'visitor@123';
      }

      
    }
  }

  /**
   * Quick login for Asset Management admin - for demo purposes
   */
  quickLoginAssetAdmin(): void {
    this.username = 'admin@test.com';
    this.password = 'password';
    this.role = 'asset-management';
    this.loginAssetManagement();
  }

  /**
   * Quick login for Asset Management manager - for demo purposes
   */
  quickLoginAssetManager(): void {
    this.username = 'manager@test.com';
    this.password = 'password';
    this.role = 'asset-management';
    this.loginAssetManagement();
  }

  /**
   * Quick login for Asset Management user - for demo purposes
   */
  quickLoginAssetUser(): void {
    this.username = 'user@test.com';
    this.password = 'password';
    this.role = 'asset-management';
    this.loginAssetManagement();
  }
}
